var _g, _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 29,
    viewBox: "0 0 26 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1744_14519)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33301 0.212891C1.78072 0.212891 1.33301 0.660605 1.33301 1.21289V27.2129C1.33301 27.7652 1.78072 28.2129 2.33301 28.2129H23.6663C24.2186 28.2129 24.6663 27.7652 24.6663 27.2129V4.87956L19.9997 0.212891H2.33301Z",
    fill: "#E9F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9995 0.212891V4.87956H24.6662L19.9995 0.212891Z",
    fill: "#C2CDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.166504,
    y: 11.8796,
    width: 25.6667,
    height: 11.6667,
    rx: 1,
    fill: "#F14848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75746 20.7129V14.8947H7.93928C8.38625 14.8947 8.76125 14.978 9.06428 15.1447C9.3692 15.3114 9.59931 15.5405 9.75462 15.8322C9.91181 16.122 9.99041 16.4515 9.99041 16.8208C9.99041 17.194 9.91181 17.5254 9.75462 17.8152C9.59742 18.1049 9.36541 18.3332 9.05859 18.4998C8.75178 18.6646 8.37393 18.747 7.92507 18.747H6.47905V17.8805H7.78303C8.04439 17.8805 8.2584 17.835 8.42507 17.7441C8.59174 17.6532 8.71484 17.5282 8.79439 17.3691C8.87583 17.21 8.91655 17.0273 8.91655 16.8208C8.91655 16.6144 8.87583 16.4326 8.79439 16.2754C8.71484 16.1182 8.59079 15.996 8.42223 15.9089C8.25556 15.8199 8.0406 15.7754 7.77734 15.7754H6.81143V20.7129H5.75746ZM12.8775 20.7129H10.9059V14.8947H12.9173C13.4949 14.8947 13.9911 15.0112 14.4059 15.2441C14.8226 15.4752 15.1426 15.8076 15.3661 16.2413C15.5896 16.675 15.7013 17.194 15.7013 17.7981C15.7013 18.4042 15.5887 18.925 15.3633 19.3606C15.1398 19.7962 14.8169 20.1305 14.3945 20.3635C13.9741 20.5964 13.4684 20.7129 12.8775 20.7129ZM11.9599 19.801H12.8263C13.2317 19.801 13.5697 19.7271 13.8406 19.5794C14.1114 19.4297 14.315 19.2072 14.4513 18.9118C14.5877 18.6144 14.6559 18.2432 14.6559 17.7981C14.6559 17.353 14.5877 16.9837 14.4513 16.6902C14.315 16.3947 14.1133 16.1741 13.8462 16.0282C13.5811 15.8805 13.2515 15.8066 12.8576 15.8066H11.9599V19.801ZM16.7028 20.7129V14.8947H20.43V15.7782H17.7567V17.3578H20.1744V18.2413H17.7567V20.7129H16.7028Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1744_14519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.3333,
    height: 28,
    fill: "white",
    transform: "translate(1.33301 0.212891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf01);
export default __webpack_public_path__ + "static/media/PDF_01.63653c8609faca1974fd5963661a0b9f.svg";
export { ForwardRef as ReactComponent };